import React from 'react';
import { Login } from './login';

export const LoginPage: React.FC = () => {
  return <Login />;
};
